const normalizeBaseUrl = (url: string) => url.replace(/\/+$/, '');

const AMPLAR_CONTENT_BASE_URL = normalizeBaseUrl(
  import.meta.env.VITE_AMPLAR_CONTENT_BASE_URL ?? '',
);
const MY_HEALTH_CONTENT_BASE_URL = normalizeBaseUrl(
  import.meta.env.VITE_MY_HEALTH_CONTENT_BASE_URL ?? '',
);

export const AMPLAR_EXTERNAL_LINKS = {
  TERMS_OF_SERVICE: AMPLAR_CONTENT_BASE_URL
    ? `${AMPLAR_CONTENT_BASE_URL}/terms-and-conditions`
    : '',
  PRIVACY_COLLECTION_NOTICE: AMPLAR_CONTENT_BASE_URL
    ? `${AMPLAR_CONTENT_BASE_URL}/privacy-collection-notice`
    : '',
  PRIVACY_POLICY: '',
  FAQ: AMPLAR_CONTENT_BASE_URL ? `${AMPLAR_CONTENT_BASE_URL}/faq` : '',
};

export const MY_HEALTH_EXTERNAL_LINKS = {
  TERMS_OF_SERVICE: MY_HEALTH_CONTENT_BASE_URL
    ? `${MY_HEALTH_CONTENT_BASE_URL}/terms-and-conditions`
    : '',
  PRIVACY_COLLECTION_NOTICE: MY_HEALTH_CONTENT_BASE_URL
    ? `${MY_HEALTH_CONTENT_BASE_URL}/information-collection-notice`
    : '',
  PRIVACY_POLICY: MY_HEALTH_CONTENT_BASE_URL
    ? `${MY_HEALTH_CONTENT_BASE_URL}/privacy-policy`
    : '',
  FAQ: MY_HEALTH_CONTENT_BASE_URL
    ? `${MY_HEALTH_CONTENT_BASE_URL}/patient-portal/faq`
    : '',
};

export const EXTERNAL_LINKS = {
  DISCLAIMER: 'https://onlinedoctor.amplarhealth.com.au/',
  APPLE_STORE_APP:
    'https://apps.apple.com/au/app/my-amplar-health/id6784545818',
  GOOGLE_PLAY_STORE_APP:
    'https://play.google.com/store/apps/details?id=au.com.amplarhealth',
};
